export default __webpack_public_path__ + "static/media/mail.a247a5b4.svg";